import { Fragment } from 'react'

import { Editor } from '@tiptap/react'

import { useStaticIntl } from '../../../../i18n/index.js'
import { MenuBooleanItem } from '../../../components/BubbleMenuBooleanItem.js'
import { MenuMultiOptionItem } from '../../../components/BubbleMenuSelectItem.js'

import { ImageDescriptionForm } from './ImageDescriptionForm.js'
import { imageOptionsGenerator, isMultiOptionImageAction } from './options.js'

export const ImageMenuOptions = ({ editor }: { editor: Editor }) => {
  const imageOptions = useStaticIntl(imageOptionsGenerator)
  const showMetaInfoControls = editor.isActive('async-image', {
    hasDescription: true,
  })

  return (
    <div className="rounded-sm divide-y divide-line-subdued text-content-subdued bg-surface shadow-lg border border-line-subdued">
      <div className="overflow-auto flex items-center divide-x divide-line-subdued py-1">
        {Object.entries(imageOptions).map(([category, imageOptions]) => (
          <div className="flex" key={category}>
            {imageOptions.map((opt, i) => (
              <Fragment
                // eslint-disable-next-line react/no-array-index-key
                key={i}
              >
                {isMultiOptionImageAction(opt) ? (
                  <MenuMultiOptionItem
                    className="mx-1"
                    title={opt.tooltip(editor)}
                    options={opt.options}
                    editor={editor}
                  />
                ) : (
                  <MenuBooleanItem
                    title={opt.tooltip(editor)}
                    onClick={() => {
                      opt.action(editor)
                    }}
                    isActive={opt.isActive(editor)}
                    disabled={opt.isDisabled && opt.isDisabled(editor)}
                    disabledTitle={opt.disabledTooltip}
                    icon={opt.icon(editor)}
                  />
                )}
              </Fragment>
            ))}
          </div>
        ))}
      </div>
      {showMetaInfoControls && <ImageDescriptionForm editor={editor} />}
    </div>
  )
}
